import { HTMLAttributes, ReactNode } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Heading, TextSize, Truncated } from '@frontend/design-system';

interface Props extends HTMLAttributes<HTMLDivElement> {
  infoTip?: ReactNode;
  leftElement?: ReactNode;
  size?: TextSize;
  title: string;
}

export const TruncatableHeaderTitle = ({ infoTip, leftElement, size = 'large', title, ...rest }: Props) => {
  return (
    <div css={styles} {...rest}>
      {leftElement}
      <Heading
        className='heading'
        level={3}
        style={{
          fontSize: theme.font.size[size],
        }}
      >
        <Truncated as='span'>{title}</Truncated>
        {infoTip}
      </Heading>
    </div>
  );
};

const styles = css`
  align-items: center;
  display: flex;
  gap: ${theme.spacing(1)};
  min-width: 0;
  overflow: hidden;

  .heading {
    align-items: center;
    display: flex;
    flex-shrink: 1;
    gap: ${theme.spacing(0.5)};
    min-width: 0;

    button {
      margin-top: ${theme.spacing(0.25)};
    }
  }
`;
